import { render, staticRenderFns } from "./InquiryModal2.vue?vue&type=template&id=6d50ccc1&scoped=true"
import script from "./InquiryModal2.vue?vue&type=script&lang=js"
export * from "./InquiryModal2.vue?vue&type=script&lang=js"
import style0 from "./InquiryModal2.vue?vue&type=style&index=0&id=6d50ccc1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50ccc1",
  null
  
)

export default component.exports